import { useDialogService } from "@platform/design-system";
import { useEffect } from "react";

type CloseDialogsOnLogoutProps = {
  isAuthenticated: boolean;
};

/**
 * Clears the drawer stack whenever the session ends.
 *
 * The dialog service is mounted above the route tree and portals its drawers to
 * document.body, so nothing about losing the session unmounts them: on logout
 * the routes are replaced by the login page while an open drawer stays on
 * screen over it.
 */
const CloseDialogsOnLogout = ({
  isAuthenticated,
}: CloseDialogsOnLogoutProps): null => {
  const { closeAll } = useDialogService();

  useEffect(() => {
    if (!isAuthenticated) closeAll();
  }, [isAuthenticated, closeAll]);

  return null;
};

export default CloseDialogsOnLogout;
